import { useState } from 'react';
import AlertBanner from 'components/commercetools-ui/molecules/alert-banner';
import JustForYou from 'components/commercetools-ui/organisms/just-for-you';
import { CloseIcon } from 'components/icons';
import { usePersonalizedCartBanner } from 'frontastic/hooks';

const JustForYouTastic = ({ data }: any) => {
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { data: personalizedCartBannerData } = usePersonalizedCartBanner();
  return (
    <>
      {(successMessage || errorMessage) && (
        <div className="z-50 w-full bg-white">
          <AlertBanner alertType={successMessage ? 'success' : 'delete'} className="mx-auto my-12 max-w-[1200px]">
            <div className="flex items-center justify-between gap-16">
              <p className="text-sm">{successMessage || errorMessage}</p>
              <button
                onClick={() => {
                  setSuccessMessage(null);
                  setErrorMessage(null);
                }}
                type="button"
              >
                <CloseIcon className="size-18" />
              </button>
            </div>
          </AlertBanner>
        </div>
      )}

      <JustForYou
        {...data}
        personalizedCartBannerData={personalizedCartBannerData}
        onSuccess={(msg: string) => {
          setSuccessMessage(msg);
          setErrorMessage(null);
        }}
        onError={(msg: string) => {
          setErrorMessage(msg);
          setSuccessMessage(null);
        }}
      />
    </>
  );
};

export default JustForYouTastic;
